import React, { useState, useEffect } from "react";
import "../styles/TeacherTagsInput.css";
import { tagInputData } from "../Services/AllServices";

const TeacherTagsInput = ({ onTagsChange }) => {
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagData, setTagData] = useState([]);

  const toggleTagSelection = (tag) => {
    setSelectedTags((prevSelectedTags) =>
      prevSelectedTags.includes(tag)
        ? prevSelectedTags.filter((t) => t !== tag)
        : [...prevSelectedTags, tag]
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await tagInputData((response) => {
          if (response && response.status === "success") {
            console.log("Tag data:", response.data[0].tagData);
            setTagData(response.data[0].tagData); // Assuming tagData is nested inside response.data[0]
          } else {
            console.log("Failed to load input tag data", response);
          }
        });
      } catch (error) {
        console.error("Error fetching tags data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (onTagsChange) {
      const formattedTags = JSON.stringify(
        selectedTags.map((tag) => tag.trim())
      );
      onTagsChange(formattedTags);
    }
  }, [selectedTags, onTagsChange]);

  const topics = tagData ? Object.keys(tagData) : [];
  const categories =
    selectedTopic && tagData[selectedTopic]
      ? Object.keys(tagData[selectedTopic])
      : [];
  const tags =
    selectedTopic &&
    selectedCategory &&
    tagData[selectedTopic][selectedCategory]
      ? tagData[selectedTopic][selectedCategory]
      : [];

  return (
    <div className="tag-out-container">
      <h3 className="tags-text">Tags</h3>
      <div className="tags-section-new">
        <div className="tags-text-topic">
          <div className="dropdown-container">
            <select
              className="dropdown-select"
              value={selectedTopic}
              onChange={(e) => {
                setSelectedTopic(e.target.value);
                setSelectedCategory("");
                setSelectedTags([]);
              }}
            >
              <option value="">Select Topic</option>
              {topics.map((topic) => (
                <option key={topic} value={topic}>
                  {topic}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="dropdown-container">
          <select
            className="dropdown-select"
            value={selectedCategory}
            onChange={(e) => {
              setSelectedCategory(e.target.value);
              setSelectedTags([]);
            }}
            disabled={!selectedTopic}
          >
            <option value="">Select Category</option>
            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div className="tags-container-new">
          {tags.map((tag, i) => (
            <div
              key={i}
              className={`tag-placeholder-new ${
                selectedTags.includes(tag) ? "selected-tag" : ""
              }`}
              onClick={() => toggleTagSelection(tag)}
            >
              {tag}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeacherTagsInput;
